import Vue from 'vue';
import Router from 'vue-router';



Vue.use(Router);
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "Index" */  '@/components/home/Index.vue'),
    props: true,
  },
  // {
  //   path: '/comparator',
  //   name: 'Comparator',
  //   component: Comparator
  // },
  {
    path: '/integration-checker',
    name: 'Vérification des références',
    component: () => import(/* webpackChunkName: "IntegrationChecker" */  '@/components/IntegrationChecker'),
    props: true,
  },
  {
    path: '/shops',
    name: 'Shops',
    component: () => import(/* webpackChunkName: "Shops" */  '@/components/Shops.vue' ),
  },
  {
    path: '/inscriptions',
    name: 'Inscriptions',
    component: () => import(/* webpackChunkName: "Inscriptions" */ '../views/Inscriptions.vue')
  },
  {
    path: '/external-connections',
    name: 'ExternalConnections',
    component: () => import(/* webpackChunkName: "ExternalConnections" */  '@/components/ExternalConnections.vue' ),
  },
  {
    path: '/info',
    name: 'Info',
    component: () => import(/* webpackChunkName: "Info" */  '@/components/Info.vue'),
  },
  {
    path: '/image',
    name: 'Image',
    component: () =>  import(/* webpackChunkName: "Image" */  '@/components/Image'),
  },
  {
    path: '/log',
    name: 'Log',
    component: () => import(/* webpackChunkName: "Log" */  '@/components/Log.vue'),
    props: true,
  },
  {
    path: '/database',
    name: 'Database',
    component: () => import(/* webpackChunkName: "Database" */  '@/components/Database.vue'),
    props: true,
  },
  {
    path: '/sourcedb',
    name: 'Source Database',
    component: () => import(/* webpackChunkName: "DatabaseSource" */ '@/components/DatabaseSource'),
  },
  {
    path: '/integration',
    name: 'Intégration',
    component: () => import(/* webpackChunkName: "Integration" */ '@/components/Integration.vue'),
    props: true,
  },
  {
    path: '/integrate',
    name: 'Integrate',
    component: () =>  import(/* webpackChunkName: "Integrate" */  '@/components/Integrate'),
    props: true,
  },
  {
    path: '/sql-update',
    name: 'SQL Update',
    component: () =>  import(/* webpackChunkName: "SqlUpdate" */ '@/views/SqlUpdate'),
    props: true,
  },
  {
    path: '/query',
    name: 'Query',
    component: () =>  import(/* webpackChunkName: "Query" */ '@/components/QueryComponent'),
    props: true,
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () =>  import(/* webpackChunkName: "Chat" */  '@/components/Chat.vue'),
  },
  {
    path: '/parser-v2',
    name: 'Parser V2',
    component: () =>  import(/* webpackChunkName: "ParserV2" */'@/components/ParserV2.vue'),
    props: true,
  },
  {
    path: '/api-docs',
    name: 'ApiDocs',
    component: () => import(/* webpackChunkName: "ApiDocs" */ '../views/ApiDocs.vue')
  },
  {
    path: '/material',
    name: 'Material',
    component: () => import(/* webpackChunkName: "Material" */ '../views/MaterialManagement.vue')
  },
  {
    path: '/calls',
    name: 'Calls',
    component: () => import(/* webpackChunkName: "Calls" */ '@/views/Calls.vue'),
    props: true,
  },
  {
    path: '/stock',
    name: 'Stock',
    component: () => import(/* webpackChunkName: "Stock" */ '@/views/Stock.vue'),
  },
  {
    path: '/mail',
    name: 'Mail',
    component: () => import(/* webpackChunkName: "Mail" */ '@/views/Mail.vue'),
  },
  {
    path: '*',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "NotFound" */ '@/views/NotFound.vue'),
  },
  {
    path: '/chronopost',
    name: 'Chronopost',
    component: () => import(/* webpackChunkName: "Chronopost" */ '@/views/Chronopost.vue'),
  },
  {
    path: '/users-admin',
    name: 'UsersAdmin',
    component: () => import(/* webpackChunkName: "UsersAdmin" */ '@/views/UsersAdmin.vue'),
  },
    {
    path: '/formation',
    name: 'Formation',
    component: () => import(/* webpackChunkName: "Formation" */ '@/views/Formation.vue'),
  },
  {
    path: '/plu-tools',
    name: 'PluTools',
    component: () => import(/* webpackChunkName: "PluTools" */ '@/views/PluTools.vue'),
  },
];

const router = new Router({
  mode: 'history',
  routes,
});

// Après un déploiement, l'index.html en cache référence des chunks hashés qui n'existent
// plus → le lazy-load d'une route échoue (ChunkLoadError) et la navigation ne se fait pas.
// On force alors un rechargement vers la page demandée pour récupérer la version à jour.
const RELOAD_KEY = 'chunk-reload-attempt';

router.onError((error) => {
  const isChunkError =
    error &&
    (error.name === 'ChunkLoadError' ||
      /Loading (CSS )?chunk [^\s]+ failed/i.test(error.message || '') ||
      /Loading chunk \d+ failed/i.test(error.message || ''));

  if (!isChunkError) return;

  // Garde anti-boucle : on ne recharge qu'une fois par navigation échouée
  if (sessionStorage.getItem(RELOAD_KEY)) return;
  sessionStorage.setItem(RELOAD_KEY, '1');

  const target = (router.history && router.history.pending && router.history.pending.fullPath) || null;
  if (target) {
    window.location.assign(target);
  } else {
    window.location.reload();
  }
});

// Navigation réussie → on réarme le mécanisme pour un éventuel futur échec de chunk
router.afterEach(() => {
  sessionStorage.removeItem(RELOAD_KEY);
});

export default router;
